import React from "react";
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";
import GlobalStyle from "./GlobalStyle";

export interface IStyleProviderProps {
  children: React.ReactNode;
}

const StyleProvider = ({ children }: IStyleProviderProps) => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    {children}
  </ThemeProvider>
);

export default StyleProvider;
